import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { selectCurrentLayerGroup, selectCategory } from "@/selector";
import { getLegendRanges } from "@/util";
import "@/components/dashboard/legend/LayerLegend.less";

const LayerLegend = () => {
  const { t } = useTranslation();
  const currentLayerGroup = useSelector(selectCurrentLayerGroup);
  const category = useSelector(selectCategory);
  const ranges = getLegendRanges(currentLayerGroup, category);
  if (!ranges) return null;
  let orderedKeys = Object.keys(ranges).sort((a, b) => a - b);

  const displayLabel = (k) => {
    switch (k) {
      case "0":
      case "14":
      case "30":
      case "-26":
      case "-50":
        return k;
      default:
        return "";
    }
  };
  const legends = orderedKeys.map((k) => {
    return (
      <div key={`legend-${currentLayerGroup}-${k}`} className="legend">
        <div className="color" style={{ background: `${ranges[k]}` }}></div>
        <div className="label">
          {currentLayerGroup === "route" ? displayLabel(k) : k}
        </div>
      </div>
    );
  });
  return (
    <div className="legend-container">
      <div className="legend-title">{t(`legend.${currentLayerGroup}`)}</div>
      {legends}
    </div>
  );
};

export default LayerLegend;
